<template>
<div>
  <v-dialog :value="open" persistent max-width="900px">
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ readonly ? $t('project.info') : (edit ? $t('project.edit') : $t('project.create')) }}</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="cancel"
        >
        <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-text-field
                v-model="project.name"
                outlined
                ref="projectName"
                :label="$t('project.projectName')"
                :rules="[rules.required]"
                :readonly="readonly"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="project.description"
                outlined
                ref="description"
                :label="$t('project.description')"
                counter="2000"
                maxLength="2000"
                :readonly="readonly"
                auto-grow
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions v-if="!readonly">
        <v-btn
          @click.stop="confirmDeletion"
          class="raison-btn"
          v-if="edit"
        >
          <v-icon>mdi-delete</v-icon>
          {{ $t('global.delete') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          @click="validate"
          class="raison-btn"
          :disabled="project.name.length === 0"
        >
          <v-icon dark>mdi-content-save-outline</v-icon>
          {{ $t('global.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

    <confirm-project-deletion-dialog
      :open.sync="openConfirmDialog"
      :project="project"
      @project-deleted="onProjectDeleted"
    />
</div>
</template>

<script>
import { testEmail } from '@/utils/utils.js';
import ConfirmProjectDeletionDialog from '@/components/dashboard/ConfirmProjectDeletionDialog';

export default {
  name: 'AddProjectDialog',

  components: { ConfirmProjectDeletionDialog },

  data () {
    return {
      project: {
        name: '',
        description: ''
      },
      rules: {
        required: value => !!value || this.$i18n.t('login.rules.required'),
        email: value => {
          return testEmail(value) || this.$i18n.t('login.rules.invalidEmail');
        },
      },
      isAccountLoading: false,
      accounts: [],
      openConfirmDialog: false,
      close: false
    }
  },

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
    propProject: {
      type: Object,
      required: false,
      default: () => undefined,
    },
    validateFunction: {
      type: Function,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  methods: {
    validate () {
      this.validateFunction(this.project)
        .finally(() => {
          this.reinitData();
        });
    },

    cancel () {
      this.reinitData();
      this.$emit('cancel-edition');
    },

    testEmail: testEmail,

    reinitData () {
      this.project = Object.assign({
        name: '',
        description: ''
      });
      this.$refs.projectName.resetValidation();
    },

    confirmDeletion () {
      this.openConfirmDialog = true;
    },

    onProjectDeleted () {
      this.show = false;
      this.$emit('update:open', false)
      this.$emit('project-deleted', { projectId: this.project.id });
    },
  },

  computed: {
    show: {
      get () {
          return this.open;
      },
      set (value) {
        this.$emit('update:open', value);
      }
    }
  },

  watch: {
    open (newValue) {
      if (newValue && this.edit) {
        this.project = Object.assign({}, this.propProject);
      }
    },
  },

  created() {
  },
};
</script>